import { Flex, Spin } from 'antd'
import { useEffect } from 'react'
import { useAuth } from '../../modules/auth/contexts/Auth'

/**
 * @since 2026-01-20
 *
 * This page allows to logout the user in case of 401 response
 * @see `setupAxios()` call inside `App.tsx`
 *
 * We used to do this directly inside the `setupAxios()` call when it was inside `Auth.tsx`
 * However it was done directly inside the component body wich executed it on each render.
 * It has now been moved inside `App.tsx`
 */
const GoingToLogoutPage = () => {
  const { logout } = useAuth()

  useEffect(() => {
    logout()
    // Safety net: never strand the user on this spinner if the logout chain
    // fails to navigate away (eg. callback throws, listener unmounts early)
    const fallback = setTimeout(() => {
      if (window.location.pathname === '/auth/going-to-logout') {
        window.location.href = '/auth/login'
      }
    }, 5000)
    return () => clearTimeout(fallback)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Flex vertical gap={10} align="center" justify="center">
      <Spin />
    </Flex>
  )
}

export default GoingToLogoutPage
